import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { formsApi } from '@/api/forms';
import { queryKeys } from '@/lib/queryKeys';
import { useAuth } from '@/contexts/AuthContext';
import { FileText, Inbox, Plus } from 'lucide-react';

export function DashboardHomePage() {
  const { user } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.forms.all,
    queryFn: () => formsApi.list(),
  });

  const forms = data?.forms ?? [];
  const totalSubmissions = forms.reduce((sum, f) => sum + (f.submissionCount ?? 0), 0);
  const activeForms = forms.filter((f) => f.isActive).length;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Bem-vindo, {user?.name}</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl border border-gray-200 p-5">
          <div className="flex items-center gap-3 mb-2">
            <FileText className="h-5 w-5 text-gray-400" />
            <span className="text-sm text-gray-500">Formularios</span>
          </div>
          <p className="text-2xl font-bold">{isLoading ? '-' : `${activeForms}/${forms.length}`}</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-5">
          <div className="flex items-center gap-3 mb-2">
            <Inbox className="h-5 w-5 text-gray-400" />
            <span className="text-sm text-gray-500">Total de Envios</span>
          </div>
          <p className="text-2xl font-bold">{isLoading ? '-' : totalSubmissions}</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-5 flex items-center justify-center">
          <Link
            to="/forms/new"
            className="flex items-center gap-2 text-primary hover:text-primary-dark font-medium"
          >
            <Plus className="h-5 w-5" />
            Criar Novo Formulario
          </Link>
        </div>
      </div>

      {forms.length > 0 && (
        <div className="bg-white rounded-xl border border-gray-200">
          <div className="px-5 py-4 border-b border-gray-100">
            <h2 className="font-semibold">Seus Formularios</h2>
          </div>
          <div className="divide-y divide-gray-100">
            {forms.slice(0, 5).map((form) => (
              <Link
                key={form.id}
                to={`/forms/${form.id}`}
                className="flex items-center justify-between px-5 py-3 hover:bg-gray-50 transition-colors"
              >
                <div>
                  <p className="font-medium">{form.name}</p>
                  <p className="text-sm text-gray-500">/f/{form.slug}</p>
                </div>
                <div className="text-sm text-gray-500">
                  {form.submissionCount ?? 0} envios
                </div>
              </Link>
            ))}
          </div>
          {forms.length > 5 && (
            <div className="px-5 py-3 border-t border-gray-100">
              <Link to="/forms" className="text-sm text-primary hover:underline">
                Ver todos os formularios
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
